let timeout;
const debounce = (fn, delay) => {
	return (...args) => {
		clearTimeout(timeout);

		timeout = setTimeout(() => {
			fn(...args);
		}, delay);
	};
};

export default debounce;
